import React, { useEffect, useState, useRef, useContext, createContext, forwardRef } from "react";
import ReactDOM from "react-dom";
import {
  FormPayment,
  FormPaymentType,
  InputFormPayment,
  FlagsContainerRow,
  FlagsContainer,
  CheckoutTypeFlags,
  ImgFlag,
  InfoUserCardBox,
  CheckoutLPLabelInput,
  InputCardNumber,
  BoxSelectCheckoutLP,
  SelectCheckoutPayment,
  InputCardName,
  InputSecurityCode,
  CheckoutAllowTerms,
  OptionContainer,
  Option,
  InfoContainer,
  Info,
  DivTeste,
  Forms,
  Button,
  OptionTeste,
  DataList,
  InputTeste,
  DataListColors,
  InputTesteColors,
} from "./TesteStyles";

import CircleLoader from "../../../components/CircleLoader/CircleLoader";
// import { PaymentPageLoaderContext } from "../../../contexts/PaymentPageLoader";

import { PaymentPageLoaderContext } from "../../../contexts/PaymentPageLoader";

// import { v4 as uuidv4 } from 'uuid';

import AuthSetup from "../../../components/AuthSetup/AuthSetup";
// import PopUp from "../../../components/PopUp";

import { InformationPopUpContext } from "../../../contexts/informationPopUp";
import { SignalCellularNoSimOutlined } from "@material-ui/icons";

import { Link } from "react-router-dom";

function Teste(props) {
  const { showInformationPopUp } = useContext(InformationPopUpContext);
  const _dado = props.location.state?.count;

  const [values, setValues] = useState("");
  console.log("[value]", values);
  if(!values) setValues("Thalyson Menezes")

  const cssProps = {
    marginBlock: "26px",
    height: "30px",
    width: "20%",
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    return () => {
      console.log("saiu")
    };
  }, []);

  const handlePage1 = async () => {
    // console.log("[handlePage dado]", dado);
    props.history.push("/teste2", { count: _dado || 0 });
  };

  const handlePage2 = async () => {
    // console.log("[handlePage dado]", dado);
    props.history.push("/teste3", { count: _dado || 0 });
  };

  // const redirect = (e) => {
  //   e.preventDefault();
  //   window.location.assign("https://google.com");
  // };

  const str = "thalyson\r\ncantamuito\r\ngsfdgsfdg\ngdfsgsdfg";
  return (
    <>
      <button type="button" onClick={handlePage1} style={{ height: "65px" }}>
        Pagina para teste2
      </button>
      <button type="button" onClick={handlePage2} style={{ height: "65px" }}>
        Pagina para teste3
      </button>

      <CircleLoader width="23" height="23" fill="#000" />

      <input
        style={cssProps}
        name="campo"
        value={values}
        maxLength={19}
        pattern="[0-9]*"
        onChange={(e) => {
          const { name: _name, value: _value } = e.target;
          const standardCard = _value.replace(/\s/g, "");

          const masked =
            standardCard.length <= 15
              ? standardCard.replace(/(\d{0,4})(\d{0,6})(\d{0,5})/, (_, g1, g2, g3) => {
                  if (g3) return `${g1} ${g2} ${g3}`;
                  if (g2) return `${g1} ${g2}`;
                  return g1;
                })
              : standardCard.replace(/(.{4})/g, "$1 ").trim();

          setValues(masked);
        }}
      />

      {str.split(/(\r\n)|(\n)/).map((item, i) => (
        <div key={i}>{item}</div>
      ))}
    </>
  );
}

export default Teste;
